'use client';
import React from 'react';

export default function FindYourCommunityBtn() {
  const scrollToTop = () => {
    window.scrollTo({ top: 100, left: 0, behavior: 'smooth' });
  };
  return (
    <button className="submit-btn" onClick={scrollToTop}>
      Find Your Community!
    </button>
  );
}
